// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Gy50","paramInput":"JobSimulator_paramInput__3wW5D","input":"JobSimulator_input__3IvZP"};